import logo_img from './logo3.png';
import PythonFullstack_img from './PythonFullstack.png';
import JavaFullStack_img from './JavaFullStack.png';
import DotNetfullstack_img from './DotNetfullstack.png';
import ArtificialIntelligence_img from  './ArtificialIntelligence.png';
import DataScienceandAnalyst_img from  './DataScience&Analyst.jpg';
import webprogramming_img from  './webprogramming.png';
import automationtest_img from './automationtest.png';
import MERN_img from './MERMstack.png';
import MEANstack_img from './MEANstack.png';
import Scrummaster_img from './ScrumMaster.png';
import uiux_img from './UIUX.png';
import AWS_img from  './AWS.png';
import Cloudtechnology_img from './Cloudtechnology.png';
import Advancedexcel_img from './advancedexcel.png';
import Tally_img from './Tally.png';
import offer_img from './offer_img.jpg';
import VerifiedProvider_img from './VerifiedProvider.png';
import JFSLogo_img from './JFSLogo.jpeg';
import JavaFullstack_pdf from './Java-Full-Stack-upl-Boucher...pdf';
import MphasisLimited_img from './MphasisLimited.jpeg';
import PythonFullstackdisplay_img from './PythonFullstackdisplay.webp';
import ArtificialIntelligencedisplay_img from './ArtificialIntelligencedisplay.webp';
import DataScienceandAnalystdisplay_img from './DataScienceandAnalystdisplay.png';
import DotNetfullstackdisplay_img from './DotNetfullstackdisplay.jpg';
import Automationtestbisplay_img from './Automationtestdisplay.jpg';
import WebProgrammingdispaly_img from './WebProgrammingdispaly.jpg';
import MERNdisplay_img from './MERNdisplay.jpg';
import ScrumMasterdisplay_img from './ScrumMasterdisplay.webp';
import UIUXdisplay_img from './UIUXdisplay.jpg';
import AWSdipaly_img from './AWSdipaly.jpg';
import CloudTechnologydisplay_img from './CloudTechnologydisplay.jpg';
import AdvancedExceldisplay_img from './AdvancedExceldisplay.jpg';
import Tallydisplay_img from './Tallydisplay.png';
import loginbg from "./loginbg.jpg"
import bg_img from "./bg_img.jpg"

export const assets ={
    logo_img,
    JavaFullStack_img,
    PythonFullstack_img,
    DotNetfullstack_img,
    ArtificialIntelligence_img,
    DataScienceandAnalyst_img,
    webprogramming_img,
    automationtest_img,
    MERN_img,
    MEANstack_img,
    Scrummaster_img ,
    uiux_img,
    AWS_img,
    Cloudtechnology_img ,
    Advancedexcel_img,
    Tally_img,
    VerifiedProvider_img,
    JFSLogo_img,
    JavaFullstack_pdf,
    MphasisLimited_img,
    PythonFullstackdisplay_img ,
    ArtificialIntelligencedisplay_img,
    DataScienceandAnalystdisplay_img,
    DotNetfullstackdisplay_img,
    Automationtestbisplay_img,
    WebProgrammingdispaly_img,
    MERNdisplay_img,
    ScrumMasterdisplay_img,
    UIUXdisplay_img,
    AWSdipaly_img,
    CloudTechnologydisplay_img,
    AdvancedExceldisplay_img,
    Tallydisplay_img,
    offer_img,
    loginbg,
    bg_img,
    
}
